import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_INVOICEROUTE_LOADING = 'GET_INVOICEROUTE_LOADING';
export const GET_INVOICEROUTE_SUCCESS = 'GET_INVOICEROUTE_SUCCESS';
export const GET_INVOICEROUTE_REJECT = 'GET_INVOICEROUTE_REJECT';

//* ACTIONS ------------------------------------------------
export const getInvoiceRouteLoading = () => ({ type: GET_INVOICEROUTE_LOADING });
export const getInvoiceRouteSuccess = (payload) => ({ type: GET_INVOICEROUTE_SUCCESS, payload });
export const getInvoiceRouteReject = (payload) => ({ type: GET_INVOICEROUTE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getInvoiceRouteRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/InvoiceRoutes`, options);
};

